var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActiveGlobalNavBorder = function SvgActiveGlobalNavBorder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#active-global-nav-border_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#0C0C0F",
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    stroke: "url(#active-global-nav-border_svg__b)",
    rx: 7.5
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27.444,
    height: 27.444,
    x: 2.278,
    y: 2.278,
    stroke: "#0C0C0F",
    strokeOpacity: 0.4,
    rx: 5.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "active-global-nav-border_svg__b",
    x1: 2.222,
    x2: 39.367,
    y1: 30.222,
    y2: 25.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DF2AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.807,
    stopColor: "#EAF67C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CECCE9"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "active-global-nav-border_svg__a",
    width: 48,
    height: 48,
    x: -8,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_284_24806"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_284_24806",
    result: "shape"
  })))));
};
export default SvgActiveGlobalNavBorder;